import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class DataManagerAvailableRoute extends Route {
	@service('model-manager/source-types')
	declare mmSourceTypesService: Service.ModelManager.SourceTypes;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('model-manager/metrics') declare mmMetricsService: Service.ModelManager.Metrics;

	override async beforeModel() {
		if (window.location.hash === '#custom') {
			this.navigationService.transitionToRoute(
				'datamanager.available.source-type-info',
				'Custom',
			);
		}

		// Awaited: the Show filter resolves pre-built metrics from metric records, and its
		// getters are cached, so records loaded after the first render are not picked up.
		await this.mmMetricsService.requestMetrics();
	}
}
